import { v4 as uuidv4 } from 'uuid';
import { appdata } from './internalModules';
import {Scenario} from './internalModules';

export class ScenarioRow {
  className: string
  guid: string
  wTypeId: string
  parentScenario: Scenario
  amount: number

  get gwp() {
    let gwpsf = appdata.getWallType(this.wTypeId).gwpsf;
    if (this.parentScenario.calcMethod === 'sqft') {
      return this.amount * gwpsf;
    }
    else {
      //calc by percentage of total area
      return (this.amount/100) * this.parentScenario.totalArea * gwpsf;
    }
  }

  get area() {
    if (this.parentScenario.calcMethod === 'sqft') {
      return this.amount;
    }
    else {
      //calc by percentage of total area
      return (this.amount/100) * this.parentScenario.totalArea;
    }
  }

/*   set gwp(value: number) {
    this.gwp = value
  } */
  
  constructor(scenario: Scenario) {
    this.className = 'ScenarioRow'
    this.guid = uuidv4();
    this.wTypeId = appdata.getWallTypeArray()[0].guid;
    this.parentScenario = scenario //the parent scenario
    this.amount = 0; // the area or percentage depending on calc method
  }

  //custom method to convert to json
  toJSON(): object {
    return {
      className: this.className,
      guid: this.guid,
      wTypeId: this.wTypeId,
      parentScenario: this.parentScenario.guid,
      amount: this.amount.toString()
    }
  }


}